import { createSelector } from 'reselect';
import moment from 'moment';
import i18n from '../../i18n';

export const selectMyTripsFeatureState = (state) => state.myTrips;

export const selectRebookPassengers = createSelector(
  selectMyTripsFeatureState,
  (state) => state && state.rebookPassengers
);

export const selectCheckedRebookPassengers = createSelector(
  selectMyTripsFeatureState,
  (state) =>
    state &&
    state.rebookPassengers &&
    state.rebookPassengers.filter((passenger) => passenger.isCheck === true)
);

export const selectMytrips = createSelector(
  selectMyTripsFeatureState,
  (state) => state && state.myTripsResults && state.myTripsResults.myCrowd
);
export const selectMytripsCount = createSelector(
  selectMyTripsFeatureState,
  (state) => state && state.myTripCount && state.myTripCount.tripCount
);

export const selectLastDutyOfCareDateChecked = createSelector(
  selectMyTripsFeatureState,
  (state) => state && state.lastCheckedDate
);

export const selectTripIsAnyFilterApplied = createSelector(
  selectMyTripsFeatureState,
  (state) => state && state.isAnyFilterApplied
);

export const selectChangeRes = createSelector(
  selectMyTripsFeatureState,
  (state) => state && state.changeResTrip
);
export const selectTripsFilters = createSelector(
  selectMyTripsFeatureState,
  (state) => state && state.myTripsResults && state.myTripsResults.destinationForFilter
);

export const selectPageMessages = createSelector(
  selectMyTripsFeatureState,
  (state) => state && state.messages
);

export const selectLoadingState = createSelector(
  selectMyTripsFeatureState,
  (state) => state && state.loadingState
);

export const selectMyTripsModified = createSelector(
  selectMytrips,
  (state) =>
    state &&
    state.map((trip) => ({
      ...trip,
      isOld: moment(trip.EndDate).isBefore(),
    }))
);

export const selectFilteredTrips = createSelector(
  selectMyTripsModified,
  selectTripsFilters,
  (state, filters) => {
    if (!state || !filters) {
      return state;
    }

    const filterDestination = filters.filter(({ Checked }) => Checked).map(({ Code }) => Code);
    return state.filter(({ TripTo }) => filterDestination.includes(TripTo));
  }
);

export const selectTripSelected = createSelector(
  selectMyTripsFeatureState,
  (state) => state && state.tripSelected
);

export const selectTripKeySelected = createSelector(
  selectTripSelected,
  (state) => state && state.TripKey
);

export const selectPaymentFeatureState = (state) => state.payment;

export const selectReceipt = createSelector(
  selectPaymentFeatureState,
  (state) => state && state.receiptResponse
);

export const selectFirstReceipt = createSelector(
  selectPaymentFeatureState,
  (state) => state && state.receiptResponse && state.receiptResponse[0]
);
export const selectReceiptMultiPnr = createSelector(
  selectPaymentFeatureState,
  (state) => state && state.receiptResponse && state.receiptResponse
);
export const selectConstructedEvent = createSelector(selectFirstReceipt, (state) => {
  const tripEvents = [];
  if (state.AirResponseDetails !== null) {
    tripEvents.push({
      Id: state.AirResponseDetails.Id,
      Title: i18n.t('tripHub:TripHubScreen.AirportDepartureTime'),
      TripKey: state.TripId,
      notEditable: true,
      EventDate: moment(
        state.FromDate + ' ' + (state.AirResponseDetails.AirLegs[0].DepartTime || '')
      ).format(),
      type: 'air',
    });
    tripEvents.push({
      Id: state.AirResponseDetails.Id,
      Title: i18n.t('tripHub:TripHubScreen.AirportArrivalTime'),
      TripKey: state.TripId,
      EventDate: moment(
        state.ToDate + ' ' + (state.AirResponseDetails.AirLegs[0].ArrivalTime || '')
      ).format(),
      notEditable: true,
      type: 'air',
    });
  }
  if (state.CarResponseDetails.length > 0) {
    tripEvents.push({
      Id: state.CarResponseDetails[0].HotelConfirmationNumber,
      Title: i18n.t('tripHub:TripHubScreen.CarPickupDate'),
      TripKey: state.TripId,
      notEditable: true,
      EventDate: moment(state.CarResponseDetails[0].PickupDate || state.FromDate).format(),
      type: 'car',
    });
    tripEvents.push({
      Id: state.CarResponseDetails[0].ConfirmationNumber,
      Title: i18n.t('tripHub:TripHubScreen.CarDropOffDate'),
      TripKey: state.TripId,
      EventDate: moment(state.CarResponseDetails[0].DropoffDate || state.ToDate).format(),
      notEditable: true,
      type: 'car',
    });
  }
  if (state.HotelResponseDetails.length > 0) {
    tripEvents.push({
      Id: state.HotelResponseDetails[0].HotelConfirmationNumber,
      Title: i18n.t('tripHub:TripHubScreen.HotelCheckinDate'),
      TripKey: state.TripId,
      notEditable: true,
      EventDate: moment(state.HotelResponseDetails[0].CheckInDateText || state.FromDate).format(),
      type: 'hotel',
    });
    tripEvents.push({
      Id: state.HotelResponseDetails[0].HotelConfirmationNumber,
      Title: i18n.t('tripHub:TripHubScreen.HotelCheckoutDate'),
      TripKey: state.TripId,
      EventDate: moment(state.HotelResponseDetails[0].CheckOutDateText || state.ToDate).format(),
      notEditable: true,
      type: 'hotel',
    });
  }

  return tripEvents;
});

export const selectReceiptPassengers = createSelector(selectFirstReceipt, (state) => {
  if (!state) {
    return state;
  }

  return state.Passengers;
});

export const selectReceiptSortedElements = createSelector(selectFirstReceipt, (state) => {
  if (!state) {
    return state;
  }

  const res = [];

  if (state.AirResponseDetails) {
    state.AirResponseDetails.AirLegs.forEach((item) => {
      res.push({
        ...item,
        sortDate: moment(item.AirSegments[0].DepartureDate),
        cardType: 'air',
      });
    });
  }

  if (state.CarResponseDetails && state.CarResponseDetails.length > 0) {
    state.CarResponseDetails.forEach((item) => {
      res.push({
        ...item,
        sortDate: moment(item.PickupDate),
        cardType: 'car',
      });
    });
  }

  if (state.HotelResponseDetails && state.HotelResponseDetails.length > 0) {
    state.HotelResponseDetails.forEach((item) => {
      res.push({
        ...item,
        sortDate: moment(item.CheckInDate),
        cardType: 'hotel',
      });
    });
  }

  if (state.RailResponseDetails) {
    state.RailResponseDetails.RailLegs.forEach((item) => {
      res.push({
        ...item,
        cardType: 'rail',
      });
    });

    // we return rail without any order because rail works alone
    return res;
  }

  return res.sort((a, b) => a.sortDate.unix() - b.sortDate.unix());
});

export const selectTripSelectedAir = createSelector(selectReceipt, (state) => {
  if (!state) {
    return null;
  }

  return state.AirResponseDetails ? [state.AirResponseDetails] : null;
});

export const selectFirstTripSelectedAir = createSelector(selectFirstReceipt, (state) => {
  if (!state) {
    return null;
  }
  return state.AirResponseDetails ? [state.AirResponseDetails] : null;
});

export const selectTripSelectedCar = createSelector(
  selectReceipt,
  (state) => state && state.CarResponseDetails?.[0]
);

export const selectTripSelectedHotel = createSelector(
  selectReceipt,
  (state) => state && state.HotelResponseDetails?.[0]
);

export const selectTripSelectedCenterMap = createSelector(
  selectReceipt,
  selectTripSelectedCar,
  selectTripSelectedHotel,
  (receipt, car, hotel) => {
    if (!receipt) {
      return receipt;
    }

    if (receipt.IsHotelExists) {
      return {
        latitude: hotel.Latitude,
        longitude: hotel.Longitude,
      };
    } else if (receipt.IsCarExists) {
      return {
        latitude: car.PickupLatitude,
        longitude: car.PickupLongitude,
      };
    } else {
      // Default center map is DFW airport
      return {
        latitude: 32.89748,
        longitude: -97.040443,
      };
    }
  }
);

export const selectReceiptIsChangeable = createSelector(
  selectReceipt,
  (state) => state && state.showChangeTrip
);

export const selectReceiptIsCancelable = createSelector(selectReceipt, (state) => {
  if (!state) {
    return null;
  }
  return (
    (state[0].Status?.toLowerCase() === 'pending' ||
      state[0].Status?.toLowerCase() === 'purchased') &&
    !state.IsRailExists
  );
});

export const hasNonSabreHotel = createSelector(selectReceipt, (state) => {
  if (!state) {
    return null;
  }

  const hotelList = Object.values(state).filter((obj) => obj.HotelResponseDetails?.length > 0);
  if (hotelList.length > 0) {
    for (let i = 0; i < hotelList.length; i++) {
      const checkNonSabreHotel = hotelList[i].HotelResponseDetails.find(
        (obj) => obj.Supplier.toLowerCase() !== 'sabre'
      );
      if (checkNonSabreHotel !== undefined) {
        return true;
      }
    }
  }
  return false;
});
